import { Actor } from "../actors/Actor";
import { gameData } from "../GameManager";
import { Item } from "../items/Item";

export const useItem = (actor: Actor, { item }: { item: Item }) => {
  if (item) {
    item.useItem(actor).then((a) => {
      if (actor === gameData.player) {
        gameData.selectedItem = null;
      }
    });
    return { valid: true };
  }
  return { valid: false };
};
